import { render, staticRenderFns } from "./PermissionPageCard.vue?vue&type=template&id=038c5c73&scoped=true"
import script from "./PermissionPageCard.vue?vue&type=script&lang=js"
export * from "./PermissionPageCard.vue?vue&type=script&lang=js"
import style0 from "./PermissionPageCard.vue?vue&type=style&index=0&id=038c5c73&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038c5c73",
  null
  
)

export default component.exports